import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";
import { ArrowLeft, RotateCcw, ServerCrash } from "lucide-react";

import { Button } from "@/components/ui/button";
import { GuardStatePanel } from "@/components/hocs/GuardStatePanel";

function extrairMensagem(error: unknown): string {
  if (isRouteErrorResponse(error)) return error.statusText || error.data?.message || "";
  if (error instanceof Error) return error.message;
  return "";
}

export function RouteErrorPage() {
  const navigate = useNavigate();
  const mensagem = extrairMensagem(useRouteError());

  return (
    <GuardStatePanel
      // errorElement da raiz: renderiza fora do MainLayout, então ocupa a tela toda
      className="min-h-screen bg-background"
      icon={ServerCrash}
      title="Algo quebrou ao abrir esta tela"
      description="A operação foi interrompida antes de mostrar qualquer coisa. Na maioria das vezes tentar de novo resolve; se insistir, avise a TI com a mensagem abaixo."
      footer={
        mensagem && (
          <div className="mt-6 w-full max-w-xl rounded-lg border border-border bg-muted/30 p-4 text-left">
            <p className="mb-2 font-mono text-xs font-semibold uppercase tracking-widest text-muted-foreground">
              Detalhe técnico
            </p>
            <code className="block break-words font-mono text-sm text-destructive">{mensagem}</code>
          </div>
        )
      }
      actions={
        <>
          <Button
            variant="outline"
            onClick={() => navigate("/")}
            className="w-full sm:w-auto sm:min-w-[140px]"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Ir para a Home
          </Button>
          <Button
            onClick={() => window.location.reload()}
            className="w-full sm:w-auto sm:min-w-[140px]"
          >
            <RotateCcw className="mr-2 h-4 w-4" />
            Tentar novamente
          </Button>
        </>
      }
    />
  );
}
